import { render, staticRenderFns } from "./taxAreaTabs.vue?vue&type=template&id=2b3427a2&"
import script from "./taxAreaTabs.vue?vue&type=script&lang=js&"
export * from "./taxAreaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports